import React, { useEffect, useState } from "react";
import { Row, Col, CardBody, Card, Alert, Container, Input, Label, Form, FormFeedback } from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { registerUser, apiError } from "../../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import { Link, useNavigate } from "react-router-dom";

// import images
import profileImg from "../../assets/images/logo-light.png";
import logoImg from "../../assets/images/logo.svg";
import UserService from "Api/Services/UserService";
import Spinners from "components/Common/Spinner";

const Register = props => {

  //meta title
  document.title = "Register | infuseone ";
  const [phoneNumber, setPhoneNumber] = useState();
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [name, setName] = useState('');
  const [getdesignation, setDesignation] = useState('');
  const [getQualification, setQualification] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      username: e.target.username.value,
      name: e.target.name.value,
      email: e.target.email.value,
      phone_number: e.target.phone_number.value,
      password: e.target.password.value,
      designation: e.target.designation.value,
      qualification: e.target.qualification.value
    };
    const error = {};

    if (!formData.username) {
      error.username = "User name is required.";
    }
    if (!formData.name) {
      error.name = "Name is required.";
    }
    if (!formData.email) {
      error.email = "Email is required.";
    }
    if (!formData.phone_number) {
      error.phone_number = "Phone number is required.";
    }
    if (!formData.password) {
      error.password = "Password is required.";
    }
    if (!formData.designation) {
      error.designation = "Designation is required.";
    }
    if (!formData.qualification) {
      error.qualification = "Qualification is required.";
    }

    // If there are errors, set them and return early
    if (Object.keys(error).length > 0) {
      setError(error);
      return;
    }
    setLoading(true);
    try {
      const response = await UserService.NewUserRegister(formData).json();

      if (response.status) {
        setSuccess(response.message);
        setLoading(false);
      } else {
        setLoading(false);
        setError(response.errors);
      }
    } catch (error) {
      console.error(error);
      setError('Something went wrong');
    }
  };


  const handleNameChange = (e) => {
    const regex = /^[A-Za-z\s]*$/;
    const newValue = e.target.value;
    if (regex.test(newValue)) {
      setName(newValue);
    }
  };
  // useEffect(() => {
  //   success && setTimeout(() => navigate("/login"), 2000)
  // }, [success])
  const handlePhoneNumberChange = (e) => {
    const newValue = e.target.value;
    if (/^\d{0,12}$/.test(newValue)) {
      setPhoneNumber(newValue);
    }
  };

  const handleDesignationChange = (e) => {
    const regex = /^[A-Za-z\s]*$/;
    const newValue = e.target.value;
    if (regex.test(newValue)) {
      setDesignation(newValue);
    }
  };

  const handleQualificationChange = (e) => {
    const regex = /^[A-Za-z\s]*$/;
    const newValue = e.target.value;
    if (regex.test(newValue)) {
      setQualification(newValue);
    }
  };


  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          {isLoading ? <Spinners setLoading={setLoading} /> :
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden commonboxform">
                  <div className="bg-primary-subtle">
                    <Row>
                      <Col className="col-7">
                        <div className="text-primary p-4">
                          <h5 className="text-primary">Sign up</h5>
                          <p>Sign up for your InfuseOne account today!</p>
                        </div>
                      </Col>
                      <Col className="col-5 align-self-end">
                        <img src={profileImg} alt="" className="img-fluid" />
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="pt-0">
                    {/* <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logoImg}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div> */}
                    <div className="p-2">
                      {success && (
                        <Alert color="success" style={{ marginTop: "13px" }}>
                          {success}
                        </Alert>
                      )}
                      <Form
                        className="form-horizontal"
                        onSubmit={handleSubmit}
                      >

                        <div className="mb-3">
                          <Label className="form-label">Username <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                          <Input
                            name="username"
                            type="text"
                            placeholder="Enter Username"
                          />
                          {error.username && (
                            <FormFeedback type="invalid" style={{ display: 'block' }}>{error.username}</FormFeedback>
                          )}
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Name <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                          <Input
                            name="name"
                            type="text"
                            placeholder="Enter Name"
                            value={name}
                            onChange={handleNameChange}
                          />
                          {error.name && (
                            <FormFeedback type="invalid" style={{ display: 'block' }}>{error.name}</FormFeedback>
                          )}
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Email <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                          <Input
                            id="email"
                            name="email"
                            className="form-control"
                            placeholder="Enter Email"
                            type="email"
                          />
                          {error.email && (
                            <FormFeedback type="invalid" style={{ display: 'block' }}>{error.email}</FormFeedback>
                          )}

                        </div>

                        <div className="mb-3">
                          <Label className="form-label">Phone Number <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="phone_number"
                            name="phone_number"
                            placeholder="Enter Phone Number"
                            onChange={handlePhoneNumberChange}
                            value={phoneNumber}
                          />
                          {error.phone_number && (
                            <FormFeedback type="invalid" style={{ display: 'block' }}>{error.phone_number}</FormFeedback>
                          )}
                        </div>

                        <div className="mb-3">
                          <Label className="form-label">Designation <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="designation"
                            name="designation"
                            placeholder="Enter Designation"
                            value={getdesignation}
                            onChange={handleDesignationChange}
                          />
                          {error.designation && (
                            <FormFeedback type="invalid" style={{ display: 'block' }}>{error.designation}</FormFeedback>
                          )}
                        </div>
                        <div className="mb-3">
                          <Label className="form-label">Qualification <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="qualification"
                            name="qualification"
                            placeholder="Enter Qualification"
                            value={getQualification}
                            onChange={handleQualificationChange}
                          />
                          {error.qualification && (
                            <FormFeedback type="invalid" style={{ display: 'block' }}>{error.qualification}</FormFeedback>
                          )}
                        </div>

                        <div className="mb-3">
                          <Label className="form-label">Password <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                          <Input
                            name="password"
                            type="password"
                            placeholder="Enter Password"
                          />
                          {error.password && (
                            <FormFeedback type="invalid" style={{ display: 'block' }}>{error.password}</FormFeedback>
                          )}
                        </div>

                        <div className="mt-4">
                          <button
                            className="btn btn-secondary  btn-block w-100 "
                            type="submit"
                          >
                            Sign up
                          </button>
                        </div>

                        <div className="mt-4 text-center">
                          <p className="mb-0">
                            By registering you agree to the infuseone{" "}
                            <Link to="#" className="text-primary">
                              Terms of Use
                            </Link>
                          </p>
                        </div>
                        <div className="mt-1 text-center">
                          <p>
                            Already have an account ?{" "} <Link to="/" className="font-weight-medium text-primary">
                              {" "}
                              Sign in
                            </Link>{" "}
                          </p>
                        </div>
                      </Form>

                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          }
        </Container>
      </div >
    </React.Fragment >
  );
};

export default Register;
